/**
 * general safety wrapper for any context-getting function
 */
export const withSafeContext = contextGetter => (...args) => {
  try {
    return contextGetter(...args)
  } catch (error) {
    console.error(`Error in context getter: ${error.message}`)
    return null
  }
}
